import { APIModel } from '@shared/interfaces';

import { ResponseData } from './response-data.type';
import { TaxResponseDocument } from './tax-response-document.model';
import { TaxResponseGroup } from './tax-response-group.model';
import { TaxRole } from './tax-role.enum';

function cleanUp(data: ResponseData | ResponseData[]): ResponseData | ResponseData[] {
    if (Array.isArray(data)) {
        return data.map((dataItem) => cleanUp(dataItem)) as ResponseData[];
    }

    let newData = JSON.parse(JSON.stringify(data));
    for (let key of Object.keys(data)) {
        if (data[key] === '' || data[key] === null) {
            newData[key] = undefined;
        }
    }
    return newData as ResponseData;
}

export class TaxResponse implements APIModel {
    id = -1;
    taxQuestionId = -1;
    role?: TaxRole;
    documents = [] as TaxResponseDocument[];
    dateSaved?: Date;
    groups = [] as TaxResponseGroup[];

    gatherDocuments(): TaxResponseDocument[] {
        let res = [] as TaxResponseDocument[];
        this.groups.forEach((group) => res.push(...group.gatherDocuments()));
        return res;
    }

    findFileRecordId(groupIndices: { groupId: number; nestedField?: number }[], fieldId: number): number | undefined {
        if (groupIndices.length === 0) {
            return undefined;
        }
        const currentGroup = this.groups.find((group) => group.index === groupIndices[0].groupId);
        if (currentGroup !== undefined) {
            const idx = currentGroup.findFileRecordId(groupIndices, fieldId);
            if (idx !== undefined) {
                return idx;
            }
        }
        return undefined;
    }

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.taxQuestionId = data.tax_question ?? -1;
        this.role = data.role ?? undefined;
        this.dateSaved = data.date_saved != null ? new Date(data.date_saved) : undefined;
        this.groups = (data.groups ?? []).map((gr: any) => new TaxResponseGroup().deserialize(gr));
        return this;
    }

    serialize() {
        return {
            'tax_question': this.taxQuestionId,
            'groups': this.groups.map((gr) => gr.serialize()),
        };
    }
}
